module.exports = __webpack_public_path__ + "img/bg-section-introduction-mobile.5f83fe8d.png";